if ($('.id--16').length) {
  if ($('#shipping-'+pplWidgetId).length) {
    $(document).on("click", ".sublabel[data-method-id='"+pplWidgetId+"']", function(e) {
      e.preventDefault();
      var $label = $(e.currentTarget); // konkrétní sublabel, ne všechny

      $.colorbox({
        html: '<div id="ppl-parcelshop-map" style="width:100%; height:100%;" data-country="pl" data-countries="pl" data-language="pl" data-mode="default"></div>',
        width: "90%",
        height: "90%",
        onComplete: function() {
          document.addEventListener("ppl-parcelshop-map", function(event) {
            var branch = event.detail;
            console.log(branch);

            var point = {
              pointID: String(branch.id),
              pointCode: String(branch.code),
              pointName: branch.name,
              pointStreet: branch.street,
              pointCity: branch.city,
              pointZIP: branch.zipCode,
              pointCountry: branch.country
            };

            // uložit do sessionStorage
            sessionStorage.setItem("pplBranch", JSON.stringify([point]));

            // zjistit methodId z kliknutého labelu
            var methodId = $label.data('method-id');

            // vyplnit hidden input
            $('#shipping-' + methodId + '-pickupPointId-selected').val(point.pointCode);

            // vypsat adresu do labelu
            $label.html('<a href="#" class="chosen">'+point.pointCity + ', ' + point.pointStreet +' <span class="changePPL">Zmień</span></a>');

            $.colorbox.close();
          }, { once: true });

          var link = document.createElement("link");
          link.rel = "stylesheet";
          link.href = "https://www.ppl.cz/sources/map/main.css";
          document.head.appendChild(link);

          var script = document.createElement("script");
          script.src = "https://www.ppl.cz/sources/map/main.js";
          document.head.appendChild(script);
        }
      });
    });
  }
}